import { request } from "../../config/API";
import authHeader from "./authHeader";
const endPoints = [
  // index 0
  {
    end: "user/subuser/", //for now adding subuser
    method: "get",
    description: "Get a single User (admin or subadmin)",
  },
  // index 1
  {
    end: "user/change-password",
    method: "post",
    description: "Superuser will Change Password for admin",
  },
  // index 2
  {
    end: "user", // delete admin
    method: "delete",
    description: "Superuser will Delete admin and all its",
  },
];

const getSingleUser = (userId) =>
  request.get(endPoints[0].end + userId, { headers: { ...authHeader() } });

const changePassword = (data) =>
  request.post(endPoints[1].end, data, { headers: { ...authHeader() } });
const deleteAdmin = (id, password) =>
  request.delete(
    endPoints[2].end + `/${id}`,
    { password },
    {
      headers: { ...authHeader() },
    }
  );

const superAdminFunctions = {
  getSingleUser,
  changePassword,
  deleteAdmin,
};

export default superAdminFunctions;
